import React from 'react';
import { string, shape, bool } from 'prop-types';

import './store-callout.scss';

export const StoreCallout = ({ storeInfo, isDeliveryFlow }) => {

  return (
    <div className="rental-pricing--copy">
      <div className="store-pricing">
        Rental Pricing for { storeInfo.storeName } #{ storeInfo.storeId }
      </div>
      <div className="exact-pricing text-danger">
        Estimated pricing will be determined later, but is subject to change.
      </div>
    </div>
  );
};

StoreCallout.displayName = 'StoreCallout';

StoreCallout.propTypes = {
  storeInfo: shape({
    storeName: string.isRequired,
    storeId: string.isRequired
  }).isRequired,
  isDeliveryFlow: bool
};

StoreCallout.defaultProps = {
  isDeliveryFlow: false
};
